import type { FC } from 'react';

import { useI18n } from '@cofenster/web-components';

import type { SharingLink } from '../../../server/sharingLink/repository/SharingLinkRepository';

export const Captions: FC<{ sharingLink: SharingLink; defaultLanguage?: string }> = ({
  sharingLink,
  defaultLanguage,
}) => {
  const { languageNames } = useI18n();

  return (
    <>
      {sharingLink.captions.map(({ language }) => (
        <track
          key={language}
          src={`/caption/${sharingLink.projectId}/${language}`}
          label={languageNames.of(language)}
          // The `srclang` attribute expects a BCP-47 language tag, which uses
          // hyphens and not underscores. Most browsers are fine with both
          // formats but Safari, surprise surprise, is not.
          srcLang={language.replace('_', '-')}
          kind="subtitles"
          default={language === defaultLanguage}
        />
      ))}
    </>
  );
};
